// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"1119":"a3751956","1954":"e94c8a57","2589":"d58c8f4e","7833":"3dc228af"}[chunkId] + ".css";
};